import React, { useState } from 'react';
import {
  TextField,
  Button,
  Grid,
  Typography,
  Container,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Paper,
  Box,
  Snackbar,
  Alert
} from '@mui/material';
import { settingApi } from '../../api/api';
export default function AddSubscriptionPlan() {
  const [planName, setPlanName] = useState("Silver");
  const [pricing, setPricing] = useState({ monthly: "", quarterly: "", yearly: "" });
  const [propertyLimit, setPropertyLimit] = useState("");
  const [projectLimit, setProjectLimit] = useState("");
  const [description, setDescription] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Validate values
    if (
      // !pricing.monthly || isNaN(pricing.monthly) ||
      // !pricing.quarterly || isNaN(pricing.quarterly) ||
      !pricing.yearly || isNaN(pricing.yearly)) {
      alert('Please fill in all pricing fields correctly.');
      return;
    }
    if (!propertyLimit || !projectLimit || !planName || !description) {
      alert("please fill all fields correctly.");
      return;
    }
    const payload = {
      plan_name: planName,
      property_limit: propertyLimit,
      project_limit: projectLimit,
      monthly: parseFloat(pricing.monthly),
      quarterly: parseFloat(pricing.quarterly),
      yearly: parseFloat(pricing.yearly),
      description: description
    };
    try {
      const response = await settingApi.addSubscriptionPlan(payload);
      alert('Subscription plan added successfully');
      //  Reset all fields
      setPlanName("Silver");
      setPricing({ monthly: "", quarterly: "", yearly: "" });
      setPropertyLimit("");
      setProjectLimit("");
      setDescription("");
    } catch (error) {
      console.error(error);
      alert('Failed to add plan');
    }
  };
  return (
    <Container maxWidth="md" sx={{ marginTop: 4 }}>
      <Paper elevation={3} sx={{ p: 4, borderRadius: 3 }}>
        <Typography variant="h4" gutterBottom sx={{
          fontWeight: 600,
          mb: 4,
          color: 'primary.main'
        }}>
          Add Subscription Plan
        </Typography>
        <Box component="form" onSubmit={handleSubmit}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <FormControl fullWidth>
                <InputLabel sx={{
                  color: 'text.primary',
                  '&.Mui-focused': {
                    color: 'primary.main'
                  }
                }}>
                  Plan Tier
                </InputLabel>
                <Select
                  value={planName}
                  onChange={(e) => setPlanName(e.target.value)}
                  required
                  sx={{
                    '& .MuiOutlinedInput-notchedOutline': {
                      borderColor: 'divider'
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      borderColor: 'primary.main'
                    }
                  }}
                >
                  <MenuItem value="Silver">Silver</MenuItem>
                  <MenuItem value="Gold">Gold</MenuItem>
                  <MenuItem value="Platinum">Platinum</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="subtitle1" sx={{
                fontWeight: 500,
                mb: 2,
                color: 'text.secondary'
              }}>
                Pricing Options
              </Typography>
              <Grid container spacing={2}>
                {/* <Grid item xs={12} md={4}>
                  <TextField
                    label="Monthly Price (₹)"
                    type="number"
                    fullWidth
                    value={pricing.monthly}
                    onChange={(e) => setPricing({ ...pricing, monthly: e.target.value })}
                    InputProps={{
                      startAdornment: <Typography sx={{ mr: 1 }}>₹</Typography>,
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextField
                    label="Quarterly Price (₹)"
                    type="number"
                    fullWidth
                    value={pricing.quarterly}
                    onChange={(e) => setPricing({ ...pricing, quarterly: e.target.value })}
                    InputProps={{
                      startAdornment: <Typography sx={{ mr: 1 }}>₹</Typography>,
                    }}
                  />
                </Grid> */}
                <Grid item xs={12} md={4}>
                  <TextField
                    label="Yearly Price (₹)"
                    type="number"
                    fullWidth
                    value={pricing.yearly}
                    onChange={(e) => setPricing({ ...pricing, yearly: e.target.value })}
                    InputProps={{
                      startAdornment: <Typography sx={{ mr: 1 }}>₹</Typography>,
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Description"
                fullWidth
                multiline
                rows={3}
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
            </Grid>

            <Grid item xs={12}>
              <Typography variant="subtitle1" sx={{
                fontWeight: 500,
                mb: 2,
                color: 'text.secondary'
              }}>
                Usage Limits
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <TextField
                    label="Property Limit"
                    fullWidth
                    value={propertyLimit}
                    onChange={(e) => setPropertyLimit(e.target.value)}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    label="Project Limit"

                    fullWidth
                    value={projectLimit}
                    onChange={(e) => setProjectLimit(e.target.value)}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} sx={{ mt: 2 }}>
              <Button
                type="submit"
                variant="contained"
                size="large"
                sx={{
                  px: 4,
                  py: 1.5,
                  borderRadius: 2,
                  textTransform: 'none',
                  fontSize: '1rem',
                  boxShadow: 'none',
                  '&:hover': {
                    boxShadow: 'none',
                    backgroundColor: 'primary.dark'
                  }
                }}
              >
                Create Subscription Plan
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Paper>
    </Container>
  );
}